import React, { createContext, useState, useContext } from 'react';

// Create the Context
const UserContext = createContext();

// Custom Hook to use the UserContext
export const useUserContext = () => {
    return useContext(UserContext);
};

// Provider Component
const UserProvider = ({ children }) => {
    const [user, setUser] = useState({
        id: null,
        name: '',
        email: '',
        role: '',
        settings: {},
    });

    // Update user's basic information
    const updateUserInfo = (info) => {
        setUser((prev) => ({ ...prev, ...info }));
    };

    // Set user settings
    const setSettings = (settings) => {
        setUser((prev) => ({
            ...prev,
            settings: {
                ...prev.settings,
                ...settings,
            },
        }));
    };

    // Clear all user data
    const clearUser = () => {
        setUser({
            id: null,
            name: '',
            email: '',
            role: '',
            settings: {},
        });
    };

    const value = {
        user,
        setUser, // If you need to override the entire user object
        updateUserInfo,
        setSettings,
        clearUser,
    };

    return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export default UserProvider;
